import { put, select, takeLatest } from 'redux-saga/effects'
import { BodySurveyConstants } from '../store/bodySurvey.constants'
import { IBodyParts, IBodySurveyState } from '../store/bodySurvey.types'
import { getBodySurveySelector } from '../selectors'
import { throwPcrException } from '../../../../pcr/store/pcr.actions'
import { saveBodySurvey, setFindingsValue, setSelectedBodyPartData } from '../store/bodySurvey.actions'
import { BodyAssessmentConstants } from '../../store/bodyAssessment.constants'
import { IBodyAssessmentState } from '../../store/bodyAssessment.types'
import { getBodyAssessmentSelector } from '../../selectors/getBodyAssessment.selector'
import { examMapping } from '../../../../../utilities/bodySurvey.util'
import { performWithMutexHOG } from '../../../../../services/mutexUtility.service'

export function* setFindingsComments() {
  const bodySurvey: IBodySurveyState = yield select(getBodySurveySelector)
  const bodyAssessment: IBodyAssessmentState = yield select(getBodyAssessmentSelector)
  const { selectedExam, bodySelectionMode } = bodyAssessment

  const { __selectedBodyParts, __comments, findings } = bodySurvey

  try {
    let locationBasedData: IBodyParts[] = []
    if (selectedExam === BodyAssessmentConstants.BODY_SURVEY) {
      if (bodySelectionMode.id === 1) {
        locationBasedData = __selectedBodyParts
      } else if (bodySelectionMode.id === 2) {
        locationBasedData = examMapping[BodyAssessmentConstants.EXTERNAL_SKIN]
      } else if (bodySelectionMode.id === 3) {
        locationBasedData = examMapping[BodyAssessmentConstants.GENERAL_EXTREMITIES]
      }
    } else {
      locationBasedData = examMapping[selectedExam]
    }

    if (locationBasedData?.length === 0) return
    const updatedFindings = findings?.map((finding) => {
      const location = locationBasedData?.find((loc) => loc?.id === finding.locationId)
      if (location) {
        return { ...finding, comments: __comments }
      }
      return finding
    })
    locationBasedData?.forEach((location: { id: number; name: any }) => {
      if (!findings?.some((finding) => finding.locationId === location.id)) {
        updatedFindings.push({
          locationId: location.id,
          __locationName: location.name,
          comments: __comments,
        })
      }
    })
    const filterEmptyCommentsfindings = updatedFindings.filter((finding) => finding.comments.length !== 0)
    yield put(setFindingsValue(filterEmptyCommentsfindings))
    const updatedBodyPartFindings = __selectedBodyParts.map((part) => {
      return { ...part, isExamined: true }
    })
    yield put(setSelectedBodyPartData(updatedBodyPartFindings))
    yield put(saveBodySurvey())
  } catch (e) {
    yield put(throwPcrException(`setFindingsComments() error: ${e}`))
  }
}

export function* setFindingsCommentsSaga() {
  yield takeLatest([BodySurveyConstants.SET_COMMENTS], performWithMutexHOG, setFindingsComments)
}
